var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "url(#pattern0_1437_31489)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1437_31489",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1437_31489",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1437_31489",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADwUlEQVR4nO2dvWsUQRiHn6iJWhjRQomKhaK2/hmmMaQQTPCDBJTEKIoilhaCYqd/hdiqpWLhJ5rYqZ2FsTJ+5hJt1JUJEziW3bvZu/147+73wAsHN3MzO8/t7OzNzC10LgeA28BbYNmHe30L2F915XqJtcAN4A8QpYR777pPKwpkDXC3gYh43PF5REFcySBjNS7LRjFsB5Zije2uGYeBTT5GgHexNDVgm6Tkz6UEGYMJ6TYD72NpL/aCkAHgLPAy4ZtbRow0qNtoBfVxbfACmPFtUyo7gDcVHHRUF66LSmOw4rrNAUNlyRgwIONjQD3nK67jLNBfgo+VbqpqGYcC6jns01ZZ1+kSfKxcM+oLvee7sHaJYlE0eZe3E7gf+8znlEAtVqirSB5EHS7EsSv2mYuUQFENF3WBkCI/t/QCIwmx1XBRxVHUcRSOhPSIkHnj9zU9J2S4ovuG0PuanhPSLUiIMSTEGBJiDAkxhoQYQ0KMISHGkBBjSIgxJMQYEmIMCTGGhBhDQowhIQWyAdiaMY+EFMQR4BvwF7iWIZ+EFMA+v0VutXGdlC2BeSUkZ9yOqycJC942BuaXkJy5kNCo5zPkl5Ac2ZOwVPZpxn2KEhJAf4tdlduEs5dsdIyQm8DvApbxfPBLiNI45b/134HxjF3VObLTEUIOFry26lNKueuBX7HR0mTAqMrF4xa3VEsI6UL6/QgpaiAlqauq+esJ3SoE/+8LyxV0Wce9hDQpSV3VmQrap3MKzIHJFClXE74kj4C+NsqSkEAmEqREOYyq4khIjlJO0z4SkpOUh212VatISA7XFDcS200+SEiLnAC+AF+Bo+SHhBhDQowhIcaQEGNIiDEkxBgSYgwJMYaEGENCAijlr/Y8EtKE0Dn1VVyaBeAHcJLsSEgDQufU0350XGrh7JKQBoTMqTeaVfwJrCMbEtKEZnPqjaZ4j5EdCWlxUuofMNXkvVaQkEDSzoJmZ0/XCqlq5WIzKXnK6BghVa1czCIlDxkOCUFCOmrlYj3qsgwxqYu6HSY07LXDeBs3hiG/fXXkRb0q+vzaq5DRVJKUhRZWM0pIA/p8o4YObeNSPktI/ox6Ka5xxwLSj9Wld3mzojPEGBJiDAkxhoQYQ0KMISHGkBBjSIgxJMQYEmIMCTGGhBhDQowhIb0uZLGgx3d3A5U8vjv+gHv3UHdJYUXGgyoecD9T8KK3qIui1fXBmRgA5gwcbGQ8XpW5c2sImDVw0JHReO3bqFSc/WngWcKfD/di1HxbTJW8p1EIIYTA8R/C7zqpGmxdDQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionIcon);
export default __webpack_public_path__ + "static/media/ActionIcon.37948f1d039ba9888e3d19a52d8c9bff.svg";
export { ForwardRef as ReactComponent };